import {ofType} from 'redux-observable';
import i18next from 'i18next';
import {flatMap, catchError} from 'rxjs/operators';
import {of} from 'rxjs';
import {reset} from 'redux-form';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as API from './api';
import * as Actions from './actions';
import type * as Models from './models';
import * as Constants from './constants';

const createDepartmentObservable = (institutionId: string, data: Models.FormData) =>
    API.createDepartment(institutionId, data).pipe(
        flatMap(() => [
            Actions.createDepartmentSuccess.action(),
            GlobalEventActions.updateSuccess.action(i18next.t('group_tag.groupCreated', {name: data.title})),
            reset(Constants.FORM_NAME),
        ]),
    );

const createDepartment = action$ =>
    action$.pipe(
        ofType(Actions.createDepartment.type),
        flatMap(({payload}: ReturnType<typeof Actions.createDepartment.action>) =>
            createDepartmentObservable(payload.institutionId, payload.data),
        ),
        catchError(error => of(Actions.createDepartmentFailed.action(error))),
    );

export default combineEpics(createDepartment);
